module.exports = new Promise(resolve => {
                    const env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
                        return [ 'qa', 'pprd', 'localhost' ].indexOf( chunk ) >= 0;
                    } );

                    const getURL = ( url ) => {
                        if(env === 'localhost') {
                            return 'http://localhost:3001/remoteEntry.js'
                        } else {
                            return url.replace( '(env.)', env ? env + '.' : '' );
                        }
                    }

                    // Load the Remote's Module Federation entry as remoteEntry.js: CPD's
                    // learn-components deploy sets Cache-Control: no-store ONLY on a file named
                    // remoteEntry.js, so browsers always revalidate it and pick up a redeploy on
                    // the next normal reload (avoids the stale-entry hard-refresh loop, #245).
                    // learn-components still emits moduleEntry.js as a byte-equivalent copy during
                    // the migration window, so this switch is safe to deploy after learn-components.
                    // If a prior chunk failure triggered a cache-busting reload, guardedReload
                    // added a ?cb=<ts> token to the page URL. Forward it onto the remoteEntry.js
                    // request so no cache layer (browser, CDN edge, proxy) can return a stale entry
                    // that still points at chunk hashes the latest deploy deleted. Belt-and-suspenders
                    // on top of the remoteEntry.js no-store header.
                    const cb = new URLSearchParams( window.location.search ).get('cb')
                    let remoteUrl = getURL('https://(env.)learn-components.biw.cloud/remoteEntry.js')
                    if (cb) { remoteUrl += (remoteUrl.indexOf('?') >= 0 ? '&' : '?') + 'cb=' + cb }
                    const script = document.createElement('script')
                    script.src = remoteUrl
                
                    script.onload = () => {
                      const proxy = {
                        get: (request) => window.Remote.get(request),
                        init: (arg) => {
                          try {
                            return window.Remote.init(arg)
                          } catch(e) {
                            console.log('remote container already initialized')
                          }
                        }
                      }
                      resolve(proxy)
                    }
                    document.head.appendChild(script);
                  })
                  ;